import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

// Sets an <iframe>'s src via Renderer2.setAttribute rather than Angular's
// [src] property binding. Angular's DomSanitizer intercepts [src] on
// iframe/embed/etc. and requires bypassSecurityTrustResourceUrl before it
// will accept a value -- setting the attribute directly is the same
// operation a browser allows on any hand-authored <iframe src="..."> tag,
// without needing that bypass call. The caller is still responsible for
// validating the URL before passing it in (see home.component.ts's
// youtube_parser, which only accepts an 11-character YouTube video ID).
@Directive({
  selector: 'iframe[appTrustedSrc]',
  standalone: false,
})
export class TrustedIframeSrcDirective implements OnChanges {
  @Input('appTrustedSrc') url: string | null | undefined;

  constructor(private el: ElementRef<HTMLIFrameElement>, private renderer: Renderer2) {}

  ngOnChanges(): void {
    if (this.url) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.url);
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'src');
    }
  }
}
